import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GoogleSheetsOAuthComponent } from './components';

const GOOGLE_CLIENT_ID = '50226627522-ekkero1qdgs8glk3t809ice0ld8h4i2n.apps.googleusercontent.com';

export const GoogleSheetsOAuth = () => {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
        <GoogleSheetsOAuthComponent />
      </div>
    </GoogleOAuthProvider>
  );
};